import React from 'react';
import { IconButton, Box } from '@mui/material';

// Import SVGs as React components
import { ReactComponent as MaleVoiceIcon } from '../resources/male_voice_icon.svg';
import { ReactComponent as FemaleVoiceIcon } from '../resources/female_voice_icon.svg';

const iconStyle = {
  width: 48,
  height: 48,
  transition: 'filter 0.2s, opacity 0.2s',
};

const VoiceSelector = ({ onPlayMale, onPlayFemale, disabled, disabledGender }) => {
  // Use a wrapper to apply grayscale and opacity to SVGs
  const getIconProps = (gender) => ({
    style: {
      ...iconStyle,
      filter: (disabled || disabledGender === gender) ? 'grayscale(100%)' : 'none',
      opacity: (disabled || disabledGender === gender) ? 0.3 : 1,
      pointerEvents: (disabled || disabledGender === gender) ? 'none' : 'auto',
    }
  });

  return (
    <Box display="flex" justifyContent="center" gap={4}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <IconButton
          onClick={onPlayMale}
          size="large"
          sx={{ p: 0, width: 42, height: 42 }}
          disabled={disabled || (disabledGender === 'MALE')}
        >
          <MaleVoiceIcon {...getIconProps('MALE')} />
        </IconButton>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        <IconButton
          onClick={onPlayFemale}
          size="large"
          sx={{ p: 0, width: 42, height: 42 }}
          disabled={disabled || (disabledGender === 'FEMALE')}
        >
          <FemaleVoiceIcon {...getIconProps('FEMALE')} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default VoiceSelector;
